import React from 'react';
import classNames from 'classnames';
import { Typography } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const PanelSummary = ({ classes, title, items }) => {
  const nonEmptyItems = items.filter(item => !!item.value || item.value === 0);
  const isEmpty = !nonEmptyItems.length;

  return (
    <div className={classNames({ [classes.container]: !isEmpty })}>
      {title}
      <div
        className={classNames(classes.itemsContainer, {
          [classes.itemsContainerMargin]: !isEmpty,
        })}
      >
        {nonEmptyItems.map(item => (
          <div key={item.label} className={classes.item}>
            <Typography
              variant="caption"
              className={classNames(classes.label, {
                [classes.highlight]: item.isHighlighted,
              })}
            >
              {item.label}
            </Typography>
            <Typography
              variant="subtitle2"
              className={classNames(classes.value, {
                [classes.highlight]: item.isHighlighted,
              })}
            >
              {item.value}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = theme => {
  return {
    container: {
      width: '100%',
      '&:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },
    itemsContainer: {
      width: '100%',
      display: 'flex',
    },
    itemsContainerMargin: {
      marginTop: theme.spacing(0.5),
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      '&:not(:last-child)': { marginRight: theme.spacing(1.5) },
    },
    label: {
      lineHeight: 'initial',
      color: theme.palette.text.secondary,
    },
    value: {
      lineHeight: 'initial',
      color: theme.palette.text.secondary,
    },
    highlight: {
      fontWeight: 'bold',
      color: theme.palette.text.primary,
    },
  };
};

export default withStyles(styles)(PanelSummary);
